export enum QueryKeysEnum {
  getAvailableLoyaltyPrograms = 'getAvailableLoyaltyPrograms',
  applicableLoyalties = 'applicableLoyalties',
  getLoyaltyPoints = 'getLoyaltyPoints',
}
